import { render, staticRenderFns } from "./ClinicRating.vue?vue&type=template&id=f0a88f2a&"
import script from "./ClinicRating.vue?vue&type=script&lang=js&"
export * from "./ClinicRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports